import React, { useState, useCallback, useImperativeHandle } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

const ModalGPP = React.forwardRef((props, ref) => {
  const {
    title,
    component: Component,
    actions,
    fullScreen,
    maxWidth,
    loading,
    onClose,
    disableBackdropClick,
    disableEscapeKeyDown,
    form,
    onForm,
  } = props;

  const [visible, setVisible] = useState(false);
  const [params, setParams] = useState({});
  const [sending, setSending] = useState(false);

  // open modal
  const handleOpenModal = useCallback((data) => {
    setVisible(true);
    setParams(data);
  }, []);

  // close modal
  const handleCloseModal = useCallback(() => {
    setVisible(false);
    onClose(params);
  }, [params]);

  // submit form
  const handleSubmitForm = useCallback(() => setSending(true), []);

  // render buttons footer
  const actionsButton = useCallback(
    () =>
      actions.map((action) => (
        <Button
          key={action.label}
          color={action.color || 'primary'}
          autoFocus={!!action.autoFocus}
          onClick={() => action.callback()}
          disabled={!!action.disabled}
          startIcon={action.startIcon}
          endIcon={action.endIcon}
          variant={action.variant || 'text'}
        >
          {action.label}
        </Button>
      )),
    [actions]
  );

  useImperativeHandle(ref, () => ({
    handleOpenModal,
    handleCloseModal,
  }));

  React.useEffect(() => {
    if (sending) setSending(false);
  }, [sending]);

  return (
    <Dialog
      open={visible}
      onClose={handleCloseModal}
      fullScreen={!!fullScreen}
      maxWidth={maxWidth}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick={disableBackdropClick}
      disableEscapeKeyDown={disableEscapeKeyDown}
    >
      {loading && <LinearProgress />}

      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}

      <DialogContent>
        <Component
          {...params}
          close={handleCloseModal}
          sending={sending}
          visible={visible}
          onForm={onForm}
        />
      </DialogContent>

      {actions && (
        <DialogActions>
          {/* {form && (
            <>
              <Button onClick={handleSubmitForm} color="primary">
                Confirmar Turno
              </Button>

              <Button onClick={handleSubmitForm} color="primary">
                Cancelar Turno
              </Button>
            </>
          )} */}
          {(!!fullScreen && !actions) ||
            (form && (
              <Button onClick={handleCloseModal} color="secondary">
                Retornar
              </Button>
            ))}
          {actionsButton()}
        </DialogActions>
      )}
    </Dialog>
  );
});

ModalGPP.propTypes = {
  title: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      callback: PropTypes.func.isRequired,
      color: PropTypes.string,
      autoFocus: PropTypes.bool,
      disabled: PropTypes.bool,
      variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
      startIcon: PropTypes.node,
      endIcon: PropTypes.node,
    })
  ),
  fullScreen: PropTypes.bool,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  loading: PropTypes.bool,
  onClose: PropTypes.func,
  disableBackdropClick: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  form: PropTypes.bool,
  onForm: PropTypes.func,
};

ModalGPP.defaultProps = {
  title: '',
  actions: [],
  fullScreen: false,
  maxWidth: 'md',
  loading: false,
  onClose: () => undefined,
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  form: false,
  onForm: () => undefined,
};

export default ModalGPP;
